jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '992',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

});
$('#navigation ul').delay(1000); 
$(window).scroll(function() {

  if ( $(window).scrollTop() >= 50 ) {
      $('.headermenu').addClass("fixedheadermenu");
      $('#LOGO_hypLogoWit').css("display", "none");
			$('#LOGO_hypLogo').css("display", "block");

  } else {
      $('.headermenu').removeClass("fixedheadermenu");
      $('#LOGO_hypLogo').css("display", "none");
			$('#LOGO_hypLogoWit').css("display", "block");
  }
});